/**
 * Get the current frontend base URL
 * This is used for generating QR codes and public links
 */
export const getFrontendBaseUrl = () => {
    // In browser, use current origin
    if (typeof window !== 'undefined') {
        return window.location.origin;
    }
    
    // Fallback based on environment
    if (process.env.REACT_APP_ENV === 'prod' || process.env.REACT_APP_ENV === 'production') {
        // TODO: Replace with actual production frontend URL
        return 'https://your-production-frontend-url.com';
    } else if (process.env.REACT_APP_ENV === 'uat' || process.env.REACT_APP_ENV === 'development') {
        // TODO: Replace with actual UAT frontend URL
        return 'https://your-uat-frontend-url.com';
    } else {
        return 'http://localhost:3000';
    }
};
